
import { ref } from 'vue';


export default({
    name:"UploadDocuments",
    props:['baseUrl'],
    setup(props:any){
        const loggedIn = ref(false);
        const documentsList = ref([]);
        const OfficerId = localStorage.OfficerId;//10000000 + localStorage.OfficerId + "";

        //alert("props.baseUrl = " + props.baseUrl);
        const checkDocumentsStatus = () =>{
            
            fetch( props.baseUrl + 'SecurityOfficers/ListOfDocumentsForOfficerUsingPhp?officerId='+OfficerId, {
              method: 'GET',
              headers:{
                      "Authorization":"Bearer " + localStorage.Guardtoken,
                      },
            })
            .then(response => {
              let res = response.json();
              //console.log("res = " + res);
              return res;

            })
            .then(data => {
              //console.log(data);
              documentsList.value =data;
            })
            .catch(error => {
              console.error(error)
            })
      }

        /******************/
        {
            //console.log("getScheduleForToday : ");
            var token = localStorage.getItem("Guardtoken");
            //console.log("token :  : ", token);

            if (token == null) 
                loggedIn.value = false;
            else 
            {
                loggedIn.value = true;
                checkDocumentsStatus();
            }
        }

        const isDocumentUploaded = (documentName:string) =>{

            if(documentsList.value.find(d => d == documentName))
                return true;
            return false;

        }

        const chooseDocument = (documentName:string) =>{
              //let form_data = uploadImage();
              // let form_details = document.getElementById("passportForm") as any;
              let form_details = document.getElementById(documentName + "Form") as any;
              let form_data = new FormData(form_details);
              form_data.append('officerId', localStorage.getItem("OfficerId")!)
              //console.log("form_data : ", form_data);
              form_data.append('documentName',documentName);
              fetch( props.baseUrl + 'SecurityOfficers/SaveImage', {
                method: 'POST',
                headers:{
                        "Authorization":"Bearer " + localStorage.Guardtoken,
                        },
                body: form_data
              })
              .then(response => response.json())
              .then(data => {
                //console.log(data.path)
                checkDocumentsStatus();
              })
              .catch(error => {
                console.error(error)
              })
            }

        return {
            loggedIn,
            chooseDocument,
            documentsList,
            isDocumentUploaded,
            OfficerId,
            checkDocumentsStatus,

        }


    }
})

